import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LINKS = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/storia", label: "Storia", testId: "nav-link-storia" },
  { to: "/lavori", label: "I Nostri Lavori", testId: "nav-link-lavori" },
  { to: "/#contatti-footer", label: "Contatti", testId: "nav-link-contatti" },
];

export default function Nav() {
  const { pathname } = useLocation();
  return (
    <header className="fixed top-0 z-50 w-full border-b border-slate-200 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-28 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logo.png" alt="Lattanzi Costruzioni" className="h-20 w-auto sm:h-24" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={`text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-gold ${
                pathname === l.to ? "font-semibold text-gold" : "text-slate-600"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger
              data-testid="nav-dropdown-trigger"
              className="flex items-center gap-1.5 border border-slate-300 px-4 py-2 text-xs uppercase tracking-[0.2em] text-slate-700 transition-colors duration-300 hover:border-gold hover:text-gold md:hidden"
            >
              Menu <ChevronDown className="h-3.5 w-3.5" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-52 border-slate-200 bg-white text-slate-700">
              {LINKS.map((l) => (
                <DropdownMenuItem key={l.to} asChild className="cursor-pointer focus:bg-red-50 focus:text-gold">
                  <Link to={l.to} data-testid={`${l.testId}-mobile`} className="w-full text-xs uppercase tracking-[0.2em]">
                    {l.label}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
